import reset from 'styled-reset'
import { createGlobalStyle } from 'styled-components'
import {Colors} from "./color";

interface GlobalStylesProps {
  $isWeb?: boolean
}

const GlobalStyles = createGlobalStyle<GlobalStylesProps>`
  ${reset};
  ${Colors};

  * {
    margin: 0;
    padding: 0;
    font: inherit;
    color: inherit;
    box-sizing: border-box;
    font-family: "NotoSansKR", "GmarketSans", sans-serif;
  }

  
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox  */
  input[type=number] {
    -moz-appearance: textfield;
  }

  :root {
    -webkit-tap-highlight-color: transparent;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
    cursor: default;
    line-height: 1.4;
    overflow-wrap: break-word;
    word-break: break-word;
    color-scheme: light only;
  }

  html,
  body {
    letter-spacing: -0.02rem;
    
  }

  img,
  picture,
  video,
  canvas,
  svg {
    width: 100%;
    height: auto;
    display: block;
    image-rendering:-webkit-optimize-contrast;
    transform: translateZ(0);
    backface-visibility: hidden;
  }
  video {
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
  }

  button {
    background: none;
    border: 0;
    cursor: pointer;
  }

  :where(a) {
    text-decoration: none;
    letter-spacing: -0.05rem;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  ul,
  ol,li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  :where(button, input, select, textarea) {
    border-radius: 0;
    border: none;
    width: 100%;
    background: 0 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: 0;
    text-decoration: none;
    cursor: pointer;
    -webkit-text-size-adjust: none;
  }

  a:focus-visible ,button:focus-visible {
    outline: 2px solid #111;
  }
  textarea {
    resize: none;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`

export default GlobalStyles
